import { useApiClient } from '@klareospace/pharos-lib-front-utils';
import type { Space } from '@klareospace/pharos-lib-types';
import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { createMutationCallbacks } from '@klareospace/pharos-lib-web-utils';

import { createSpaceApi, spaceKeys } from '../api';
import type { CreateSpaceParams } from '../api';

export function useCreateSpace(): UseMutationResult<Space, Error, CreateSpaceParams> {
  const client = useApiClient('admin-auth');
  const api = createSpaceApi(client);
  const queryClient = useQueryClient();

  return useMutation<Space, Error, CreateSpaceParams>({
    mutationFn: (params: CreateSpaceParams) => api.createSpace(params),
    ...createMutationCallbacks({
      invalidateKeys: [spaceKeys.all],
      queryClient,
    }),
  });
}
